import React, { useState, useEffect } from 'react';
import { Modal, Form, InputNumber, Select, Button, Typography, Space, Row, Col } from 'antd';
import { customBaseUrl, httpPut } from '../../../store/http';
import { hideLoader, showLoader } from '../../../utils/loader';
import Swal from 'sweetalert2';

const { Title, Text } = Typography;
const { Option } = Select;

const UpdateProductPricingModal = ({ showModal, hideModal, selectedProduct, merchantId, reload }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (selectedProduct) {
            form.setFieldsValue({
                priceType: selectedProduct?.priceType || 'FIXED',
                customAmount: selectedProduct?.customAmount || 0,
                discountAmount: selectedProduct?.discount || 0,
                capAmount: selectedProduct?.capPrice || 0,
            });
        }
    }, [selectedProduct, form]);

    const onFinish = async (values) => {
        const formData = new FormData();
        formData.append('capAmount', values.capAmount || 0);
        formData.append('discountAmount', values.discountAmount || 0);
        formData.append('customAmount', values.customAmount || 0);
        formData.append('product', selectedProduct.productCode);
        formData.append('userId', merchantId);
        formData.append('priceType', values.priceType);

        setLoading(true);
        showLoader();
        try {
            const response = await httpPut(`${customBaseUrl.walletUrl}/api/v1/pricing/custom-pricing`, formData);
            if (response.status === true) {
                Swal.fire('Success', response.message || 'Pricing updated successfully', 'success');
                hideModal();
                if (reload) reload();
            } else {
                Swal.fire('Error', response.message || 'Failed to update pricing', 'error');
            }
        } catch (error) {
            console.error('Error updating pricing:', error);
            Swal.fire('Error', 'An unexpected error occurred', 'error');
        } finally {
            hideLoader();
            setLoading(false);
        }
    };

    return (
        <Modal
            title={<Title level={4}>Update Pricing: {selectedProduct?.productName}</Title>}
            open={showModal}
            onCancel={hideModal}
            footer={null}
            width={500}
            centered
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                initialValues={{
                    priceType: 'FIXED',
                    customAmount: 0,
                    discountAmount: 0,
                    capAmount: 0,
                }}
            >
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="priceType"
                            label="Pricing Type"
                            rules={[{ required: true, message: 'Please select pricing type' }]}
                        >
                            <Select size="large">
                                <Option value="FIXED">FIXED</Option>
                                <Option value="PERCENTAGE">PERCENTAGE</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="customAmount"
                            label="Rate / Custom Amount"
                            rules={[{ required: true, message: 'Please enter rate' }]}
                        >
                            <InputNumber size="large" style={{ width: '100%' }} min={0} placeholder="0.00" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="discountAmount"
                            label="Discount"
                        >
                            <InputNumber size="large" style={{ width: '100%' }} min={0} placeholder="0.00" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="capAmount"
                            label="Cap Amount"
                        >
                            <InputNumber size="large" style={{ width: '100%' }} min={0} placeholder="0.00" />
                        </Form.Item>
                    </Col>
                </Row>

                <div style={{ marginTop: 24, textAlign: 'right' }}>
                    <Space>
                        <Button onClick={hideModal} size="large">
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            size="large"
                            style={{ background: '#ff6700', borderColor: '#ff6700' }}
                        >
                            Update Pricing
                        </Button>
                    </Space>
                </div>
            </Form>
        </Modal>
    );
};

export default UpdateProductPricingModal;
